<template>
  <PerfectScrollbar
    ref="perfectScrollbar"
    :tag="htmlTag"
    @ps-y-reach-end="$emit('roll-to-the-bottom')"
  >
    <slot />
  </PerfectScrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
  components: {
    PerfectScrollbar,
  },
  props: {
    htmlTag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
